import {z} from '@hono/zod-openapi';

import {supplierCatalogSearchInputSchema} from './supplierCatalogSearchInputSchema';

/** Raw catalog data is still read in the selected dealer profile context. */
export const supplierCatalogSearchRequestSchema = supplierCatalogSearchInputSchema
  .extend({authorizationProfileId: z.string().uuid()})
  .openapi('SupplierCatalogSearchRequest');
export type SupplierCatalogSearchRequest = z.infer<typeof supplierCatalogSearchRequestSchema>;
